import { useContext } from "react";

import { mainBannerProvider } from "./MainBannerProvider";
import type { MainBannerTranslations } from "./MainBannerTranslationProvider";

export const useMainBannerTranslations = (): MainBannerTranslations => {
  const data = useContext(mainBannerProvider);
  if (!data) {
    throw new Error(
      "MainBanner translations can't be null, please add mainBannerProvider",
    );
  }

  return data;
};
